//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('userGroupService', userGroupService);


    function userGroupService(UserGroupResource, $q) {

        var service = {};

        service.getUserGroups = function () {
            var d = $q.defer();

            UserGroupResource.getUserGroups({}, {}, function (response) {

                    d.resolve(response);

                }, function (error) {

                    d.reject(error);
                });
            return d.promise;
        };

        service.getUnassignedUserGroups = function () {
            var d = $q.defer();
            console.log("retrieving unassigned user groups...");

            UserGroupResource.getUnassignedUserGroups({}, {}, function (response) {

                    d.resolve(response);

                }, function (error) {

                    d.reject(error);
                });
            return d.promise;
        };

        service.removeUserFromGroup = function (dto) {
            var d = $q.defer();

            UserGroupResource.removeUserFromGroup({id:dto.groupId, version:dto.groupVersion}, function (response) {
                    console.log("successfully removed user from group with response: ", response);
                    d.resolve(response);
                    return;
                }, function (error) {
                    console.log("removed user from group with following error: ", error);
                    d.reject(error);
                    return;
                });
            return d.promise;
        };

        service.requestGrant = function (ids) {
            var d = $q.defer();

            UserResource.requestGrants({}, ids, function (response) {
                    console.log("successfully removed user from group with response: ", response);
                    d.resolve(response);
                    return;
                }, function (error) {
                    console.log("removed user from group with following error: ", error);
                    d.reject(error);
                    return;
                });
            return d.promise;
        };

        service.requestMultipleGrants = function (ids) {
            var d = $q.defer();

            UserResource.requestMultipleGrants({}, {ids:ids}, function (response) {
                    console.log("successfully removed user from group with response: ", response);
                    d.resolve(response);
                    return;
                }, function (error) {
                    console.log("removed user from group with following error: ", error);
                    d.reject(error);
                    return;
                });
            return d.promise;
        };

        return service;

    }


})();